import React from 'react';
import styled from 'styled-components';
import Popover from '@airasia/phoenix-components/components/Popover';
import theme from '@airasia-common/libraries/theming/theme';
import Image from '../Image';
import Text from '../Text/Text';
import Wrapper from '../Wrapper';
import Row from '../Container/Row';
import { PaymentDiscountIcon } from '../../utils/statics';
import PaymentDiscountPropTypes from './PaymentDiscount.propTypes';

const DiscountTypeWrapper = styled(Row)`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.tertiaryGreen};
  margin-right: 4px;
  border-radius: 3px;
  position: relative;
`;

DiscountTypeWrapper.defaultProps = {
  padding: ['4px', '5px'],
};

DiscountTypeWrapper.displayName = 'DiscountTypeWrapper';

const DiscountType = styled(Text)`
  color: ${({ theme }) => theme.colors.greyLight};
  font-weight: 400;
  line-height: 10px;

  ${({ bold, theme }) =>
    bold &&
    `
      color: ${theme.colors.primaryWhite};
      font-weight: 500;
      display: flex;
      margin-left: 6px;
      white-space: nowrap;
    `}
`;

DiscountType.displayName = 'DiscountType';

DiscountType.defaultProps = {
  fontSize: '12px',
};

const DescriptionLabel = styled(Text)`
  color: ${({ theme }) => theme.colors.tertiaryGreen};
  font-weight: 400;
  line-height: 20px;
`;

DescriptionLabel.defaultProps = {
  fontSize: '12px',
};

DescriptionLabel.displayName = 'DescriptionLabel';

const PopoverContent = styled(Text)`
  color: ${({ theme }) => theme.colors.greyLighter};
`;

PopoverContent.displayName = 'PopoverContent';

PopoverContent.defaultProps = {
  fontSize: '12px',
  fontWeight: 'normal',
  lineHeight: '125%',
};

const PaymentDiscount = ({ type, description, isMobileView = false }) => {
  return (
    <Wrapper marginTop={12} display={'flex'} flexDirection={['column', 'row']}>
      {type ? (
        <Row>
          <DiscountTypeWrapper>
            {!isMobileView ? (
              <Popover
                accessibile
                accessible
                content={<PopoverContent>{description}</PopoverContent>}
                position="top"
                theme="AIRASIA_CLASSIC"
                trigger="hover"
                width={200}
                zIndex={1}
                background={theme.colors.darkBlack}
                borderRadius={4}
                left={'50%'}
                marginLeft={'-112px'}
                top={'inherit'}
                bottom={'225%'}
              >
                <Image
                  src={PaymentDiscountIcon}
                  width="12px"
                  height="12px"
                  display={'flex'}
                />
                <DiscountType
                  className="payment-discount-type"
                  bold
                  marginRight={0}
                >
                  {type}
                </DiscountType>
              </Popover>
            ) : (
              <>
                <Image
                  src={PaymentDiscountIcon}
                  width="12px"
                  height="12px"
                  display={'flex'}
                />
                <DiscountType
                  className="payment-discount-type"
                  bold
                  marginRight={0}
                >
                  {type}
                </DiscountType>
              </>
            )}
          </DiscountTypeWrapper>
        </Row>
      ) : null}
      {description ? (
        <Row>
          <DescriptionLabel
            className="description-label"
            numberOfLines={isMobileView ? 2 : 1}
          >
            {description}
          </DescriptionLabel>
        </Row>
      ) : null}
    </Wrapper>
  );
};

PaymentDiscount.propTypes = PaymentDiscountPropTypes;

export default PaymentDiscount;
